import React from "react";
import { Card, Statistic, Tooltip, Typography } from "antd";
import trans from "../../../../utils";

const { Text } = Typography;

const NumbersCard = ({
  title,
  value,
  suffix,
  color,
  tooltip,
  onClick,
  popup,
}) => {
  return (
    <Tooltip title={trans(tooltip)}>
      <Card
        // hoverable
        style={{
          borderRadius: "16px",
          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
          // background:  "linear-gradient(135deg, #FFFFFF1A, rgba(255, 255, 255, 0.05))", // glass gradient
          // backdropFilter: "blur(20px) saturate(180%)", // stronger blur + richer colors
          // WebkitBackdropFilter: "blur(20px) saturate(180%)",
          border: "1px solid #EBECF0", // crisper edge
          // boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)", // deeper shadow
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: popup ? "pointer" : "",
          height: "100%",
        }}
        bodyStyle={{ padding: "12px 8px", textAlign: "center" }}
        onClick={() => onClick()}
      >
        <Statistic
          value={value}
          suffix={suffix || ""}
          valueStyle={{
            fontSize: "18px",
            fontWeight: "600",
            color: color,
            lineHeight: "1.2",
          }}
        />
        <Text
          style={{
            fontSize: "12px",
            fontWeight: "500",
            display: "block",
            marginTop: "4px",
          }}
        >
          {title}
        </Text>
      </Card>
    </Tooltip>
  );
};

export default NumbersCard;
